<template>
  <aside class="main-sidebar sidebar-dark-primary elevation-4">
    <!-- Brand Logo -->
    <router-link to="/" class="brand-link">
      <img src="/images/logo-e.png" alt="AdminLTE Logo" class="brand-image" />
      <span class="brand-text font-weight-light"
        ><img src="/images/logo-econsulte-white.png" alt="Econsulte" class=""
      /></span>
    </router-link>
    <div class="sidebar">
      <nav class="mt-2">
        <ul
          data-widget="treeview"
          role="menu"
          data-accordion="false"
          class="nav nav-pills nav-sidebar flex-column"
        >
          <li class="nav-item mt-3" v-if="parceiro.user_uf == 'ES'">
            <button-indicar></button-indicar>
            <!-- <a
              href="#"
              data-toggle="modal"
              data-target="#MainModal"
              data-route="indicacoes"
              data-route-action="indicarForm"
              title="Indicação de Serviços"
              data-modal-size="md"
              data-btn-name="<i class='fa fa-share'></i> Indicar"
              class="nav-link badge-warning"
              style="color: black"
              ><i class="nav-icon fas fa-share"></i>
              <p>Indicar Serviço</p>
            </a> -->
          </li>
          <li
            class="nav-item"
            v-for="(menu, index_menu) in menus"
            :key="index_menu"
          >
            <router-link
              :to="`${
                menu.route != null
                  ? '/' + menu.route
                  : menu.name == 'HOME'
                  ? '/'
                  : '#'
              }`"
              class="nav-link d-flex"
            >
              <i :class="`nav-icon fas fa-${menu.icone}`" v-if="menu.icone"></i>

              <span
                v-else
                class="
                  letter
                  d-flex
                  text-center
                  align-items-center
                  justify-content-center
                  mr-2
                "
                style="
                  background: #c2c7d0;
                  width: 25px;
                  height: 25px;
                  border-radius: 50%;
                "
              >
                <strong style="color: #343a40">{{
                  menu.name
                    .split(/\s/)
                    .reduce(
                      (response, word) => (response += word.slice(0, 1)),
                      ""
                    )
                }}</strong>
              </span>

              <p>
                {{ menu.name }}
                <i
                  class="right fas fa-angle-left"
                  v-if="menu.submenus && menu.submenus.length > 0"
                ></i>
              </p>
            </router-link>
            <ul class="nav nav-treeview" v-if="menu.submenus">
              <li
                class="nav-item"
                v-for="(submenu, index_submenu) in menu.submenus"
                :key="index_submenu"
              >
                <router-link :to="'/' + submenu.route" class="nav-link">
                  <i class="far fa-circle nav-icon"></i>
                  <p>{{ submenu.name }}</p>
                </router-link>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
    </div>
  </aside>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import buttonIndicar from "./../indicacoes/buttonIndicar.vue";
export default {
  components: { buttonIndicar },
  data() {
    return {
      menus: [],
      reload: false,
    };
  },
  watch: {
    $route(to, from) {
      //  console.log("mudei o to", this.reload);

      $(".main-sidebar")
        .find(".nav-item")
        .removeClass("menu-is-opening menu-open");
      $(".main-sidebar").find(".nav-treeview").removeAttr("style");
      if (to.path != "" && !to.hash) {
        $(".main-sidebar")
          .find(`a[href='${to.path}']`)
          .parents("li")
          .addClass("menu-is-opening menu-open");
      }
    },
  },

  created() {
    this.getMenu();

    //this.currentRoute = this.$router.history.current.path;

    //  console.log('currentRoute', this.currentRoute);
  },
  computed: {
    ...mapState("current_route", ["currentRoute"]),
    ...mapState("user", ["parceiro"]),
  },

  methods: {
    ...mapMutations("datatable", ["setReload"]),
    async getMenu() {
      const result = await this.$api.get("menus");
      this.menus = result.data;
    },
  },
};
</script>
